<div class="wrapper" [ngClass]="{ 'has-link': linkToProduct }">
    <div class="image">
        <app-product-image
            *ngIf="(breakpointServiceMin.breakpoint$ | async)?.isTabletOrSmaller === false"
            [image]="{ src: product.imageUrl, name: product.productName }"
            [width]="64"
            [height]="64"
            wrapperWidth="80px"
            wrapperHeight="80px"
            preset="94|94"
            preset2x="150|150"
            [variant]="imageVariant"
        ></app-product-image>
        <app-product-image
            *ngIf="(breakpointServiceMin.breakpoint$ | async)?.isTabletOrSmaller === true"
            [image]="{ src: product.imageUrl, name: product.productName }"
            [width]="40"
            [height]="40"
            wrapperWidth="48px"
            wrapperHeight="48px"
            preset="94|94"
            preset2x="150|150"
            [variant]="imageVariant"
        ></app-product-image>
    </div>
    <div class="product-header">
        <p class="brand display-label" *ngIf="product.brand">{{ product.brand.text }}</p>
        <div class="header-content">
            <div>
                <h5 class="product-name">
                    {{ product.productName }}
                </h5>
                <p class="unit-price display-label" *ngIf="show.price">
                    {{
                        'checkout.minibasket.unitPriceAndQuantity'
                            | translateSafe
                            : {
                                unitPrice: product.unitPrice,
                                quantity: quantity
                            }
                    }}
                </p>

                @if (show.properties) {
                    <div class="properties display-label">
                        @for (property of product | normalizeProperties | keyvalue; track property.key) {
                            @if (!property.value?.translation) {
                                <!-- Must be 1 line (or with starting and ending brackets on same line as span tag), or Angular adds whitespace before and after text -->
                                @if (property.value; as value) {
                                    <span class="property">
                                        <ng-container *ngIf="$any(property.key) | isDimensionProperty">
                                            {{ 'productDetail.property.' + property.key | translate }}
                                        </ng-container>
                                        {{ value.text + (value.unit ? ' ' + value.unit : '') }}
                                    </span>
                                }
                            }
                        }
                    </div>
                }

                @if (product.activeSplashes | activeSplash: 'RetailMedia' | async; as splash) {
                    <app-product-splash
                        class="splash-retail-media"
                        [text]="splash.splashDescription"
                        [type]="'retail-media'"
                        [style]="{backgroundColor: splash.ribbonColor | colorStringToHex}"
                        size="s"
                    ></app-product-splash>
                }
            </div>
            <div class="price-wrapper">
                <p class="price-value">
                    {{
                        product.unitPriceRaw * quantity | formatCurrency: 'da-DK':'DKK':'decimal' | removeTrailingZeroes
                    }}
                </p>
                <p *ngIf="show.discount && product.discountAmountRaw && product.discountAmountRaw > 0">
                    <span class="kk-visuallyhidden">{{ 'basket.line.discount' | translateSafe }}</span>
                    <span class="price-value price-value-deduction">
                        {{
                            product.discountAmountRaw * quantity
                                | formatCurrency: 'da-DK':'DKK':'decimal'
                                | removeTrailingZeroes
                                | withNegativeSign
                        }}
                    </span>
                </p>
            </div>
        </div>
    </div>
    <div class="footer">
        @if (show.points) {
            <p class="display-label points-earned">
                {{ 'checkout.minibasket.pointsEarned' | translateSafe: { pointsEarned: product.points * quantity } }}
            </p>
        }
    </div>
    @if (linkToProduct) {
        <a [attr.aria-label]="product.productName"
           (click)="productClicked.emit()"
           [routerLink]="product.productUrl"
           class="kk-link-cover"
           appSetIsFocused
        ></a>
    }
</div>
